import React from 'react';
import PropTypes from 'prop-types';

import { translateStaticContent } from '../../../helpers/translateStaticContent';

const Domestic = (props) => {
     return(
        <div className="domestic-table">
            <div className="table-column">
                 <div className="table-header">
                    {translateStaticContent('tableDataSum', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data">{props.transferAmount}</div>
            </div>
            <div className="table-column">
                <div className="table-header">
                    {translateStaticContent('tableDataCommission', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data">{props.commission}</div>
            </div>
            <div className="table-column">
                <div className="table-header">
                    {translateStaticContent('tableDataCondition', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data">{props.fromCondition}</div>
            </div>
            <div className="table-column">
                 <div className="table-header">
                    {translateStaticContent('tableDataGetTransfer', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data">{props.toCondition}</div>
            </div>
        </div>
    )   
}

export default Domestic;

Domestic.propTypes = {
    commission: PropTypes.any.isRequired,
    transferAmount: PropTypes.any.isRequired,
    toCondition: PropTypes.any.isRequired,
    fromCondition: PropTypes.any.isRequired,
    defaultStaticContentTariffs: PropTypes.object,
    activeLangStaticContentTariffs: PropTypes.object,
}
